export const isProduction = process.env.NODE_ENV === 'production';

export const posthogKey = process.env.GATSBY_POSTHOG_KEY;
export const posthogHost = process.env.GATSBY_POSTHOG_HOST;
export const isPosthogEnabled = Boolean(posthogKey && posthogHost);
